<template>
    <div class="flex flex-col h-full overflow-hidden">
        <!-- Header -->
        <PinsIndexHeader v-model="searchInput" v-model:sortValue="sortValue" />
        <!-- Body -->
        <ShadowScrollContainer>
            <PinsIndexBody v-model="searchInput" v-model:sort-value="sortValue" />
        </ShadowScrollContainer>
        <!-- Footer -->
        <PinsIndexFooter />
    </div>
</template>

<script setup>
import {PinsIndexHeader, PinsIndexBody, PinsIndexFooter} from "@/Components/Modules/Dialogs/Pins/Components";
import {ref} from "vue";
import {ShadowScrollContainer} from "@/Components";

const searchInput = ref("")
const sortValue = ref({value: ['created_at', 'asc'], label: 'Date (asc)'});
</script>
